import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface SalatiActivationResponse extends APIResponse
{

}

export class SalatiActivationResponseDtoImpl extends APIResponseDtoImpl implements SalatiActivationResponse
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/salati/salatiactivation/salatiactivationresponse.tsx